import React from 'react';
import { InstanceType } from '../../../types/database.type';

interface InstanceTypeCardProps {
  instance: InstanceType;
  selected: boolean;
  onClick: () => void;
}

const InstanceTypeCard: React.FC<InstanceTypeCardProps> = ({ instance, selected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-between p-4 border-2 rounded-lg transition-all ${
        selected ? 'border-black dark:border-white bg-gray-50 dark:bg-gray-700' : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
      }`}
    >
      <div className="text-left">
        <p className="font-semibold text-gray-900 dark:text-white">{instance.name}</p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {instance.cpu} • {instance.ram}
        </p>
      </div>
      <div className="text-right">
        <p className="text-lg font-bold text-gray-900 dark:text-white">{instance.price}</p>
        <p className="text-xs text-gray-500">per hour</p>
      </div>
    </button>
  );
};

export default InstanceTypeCard;